import { useTranslate } from "@tolgee/react";
import { isArray } from "lodash-es";
import React from "react";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import { CategoriesInput } from "../../categories/CategoriesInput.js";
import { useCategories } from "../../categories/useCategories.js";

export function FilterProjectCategory({
  value,
  setValue,
  ...props
}: FilterProps<string[]>) {
  const { t } = useTranslate("Categories");

  return (
    <CategoriesInput
      alwaysShowLabel={true}
      addParentsWhenNotIncluded={false}
      categoryIds={Array.isArray(value) ? value : [value]}
      onChange={async categories => {
        setValue(categories.map(c => c.id));
      }}
      onClear={() => setValue([])}
      label={t("Categories")}
      selectButtonLabel={t("Select categories")}
      {...props}
    />
  );
}

export function FilterProjectCategoryChips(
  props: Omit<FilterChipGroupProps<string>, "label" | "getValueLabel">
) {
  const ids = props.values
    ? isArray(props.values)
      ? props.values
      : [props.values]
    : [];
  const { resolveCategories } = useCategories();
  const categories =
    ids.length === 0
      ? []
      : resolveCategories(ids, { addParentsWhenNotIncluded: false });
  return (
    <FilterChipGroup
      {...props}
      values={categories.map(c => c.id)}
      getValueLabel={value => categories.find(c => c.id === value)?.name ?? ""}
      label=""
      displayLimit={5}
    />
  );
}
